import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import DetaljPageHeader from "../Common/Detalj/DetaljPageHeader";
import Map from "../Common/Maps/MapView";
import BilderAndMiljokontrollsobservasjonsbilderContainer from "../Common/Miljogebyr/Detalj/BilderAndMiljokontrollsobservasjonsbilderContainer";
import BilderContainer from "../Common/Miljogebyr/Detalj/BilderContainer";
import Ettersendelser from "../Common/Miljogebyr/Detalj/Ettersendelser";
import KlageinformasjonContainer from "../Common/Miljogebyr/Detalj/KlageinformasjonContainer";
import KopiContainer from "../Common/Miljogebyr/Detalj/KopiContainer";
import MiljogebyrGridOgKommentarContainer from "../Common/Miljogebyr/Detalj/MiljogebyrGridOgKommentarContainer";
import MiljokontrollContainer from "../Common/Miljogebyr/Detalj/MiljokontrollContainer";
import MiljokontrollKommentarerContainer from "../Common/Miljogebyr/Detalj/MiljokontrollKommentarerContainer";
import MottakerAvMiljogebyrContainer from "../Common/Miljogebyr/Detalj/MottakerAvMiljogebyrContainer";
import NyeEttersendelser from "../Common/Miljogebyr/Detalj/NyeEttersendelser";
import TilbakemeldingerFraBybetjenterContainer from "../Common/Miljogebyr/Detalj/TilbakemeldingerFraBybetjenterContainer";
import Spinner from "../Common/Spinner";

import { getBybetjenter as getBybetjenterAction } from "../../actions/bybetjenterActions";
import { getMiljogebyr as getMiljogebyrAction } from "../../actions/miljogebyrerActions";
import { getMiljogebyrEttersendelser as getMiljogebyrEttersendelserAction } from "../../actions/miljogebyrEttersendelserActions";

import * as title from "../../constants/titles";
import KlagebehandlingInformasjonContainer from "../Common/Miljogebyr/Detalj/KlagebehandlingInformasjonContainer";

export default function InnsynMiljogebyrDetaljPage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const [isLoadingMiljokontrollBilder, setIsLoadingMiljokontrollBilder] =
    useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = miljogebyr.ileggelsesnummer
      ? title.innsynMiljogebyrDetalj(miljogebyr.ileggelsesnummer)
      : document.title;
    dispatch(getMiljogebyrAction(id));
    dispatch(getMiljogebyrEttersendelserAction(id));
    dispatch(getBybetjenterAction());
  }, []);

  useEffect(() => {
    if (miljogebyr && miljogebyr.ileggelsesnummer) {
      document.title = title.innsynMiljogebyrDetalj(
        miljogebyr.ileggelsesnummer,
      );
    }
  }, [miljogebyr && miljogebyr.ileggelsesnummer]);

  if (miljogebyr && miljogebyr.id === id) {
    return (
      <div className="ileggelse-content-wrapper">
        <DetaljPageHeader
          pageName={"Miljøgebyr"}
          pageId={String(miljogebyr.ileggelsesnummer)}
          isMakulert={miljogebyr.isMakulert}
        />
        <Tabs
          defaultActiveKey={1}
          id="InnsynnIleggelseTabs"
          className="detailjTab"
          mountOnEnter
        >
          <Tab eventKey={1} title="Miljogebyr">
            <div className="ileggelse-tab-content-wrapper">
              <div style={{ marginBottom: 30, marginLeft: 50 }}>
                <KopiContainer />
              </div>
              <MiljogebyrGridOgKommentarContainer miljogebyr={miljogebyr} />
              <TilbakemeldingerFraBybetjenterContainer
                miljogebyrId={miljogebyr.id}
              />
              <MottakerAvMiljogebyrContainer miljogebyrId={miljogebyr.id} />
              {miljogebyr && !miljogebyr.miljoKontrollId && (
                <BilderContainer miljogebyrId={id} />
              )}
              {miljogebyr && miljogebyr.miljoKontrollId && (
                <>
                  <MiljokontrollContainer
                    miljoKontrollId={miljogebyr.miljoKontrollId}
                    setIsLoadingMiljokontrollBilder={
                      setIsLoadingMiljokontrollBilder
                    }
                  />
                  <MiljokontrollKommentarerContainer miljogebyrId={id} />
                  <BilderAndMiljokontrollsobservasjonsbilderContainer
                    miljogebyrId={id}
                    isLoadingMiljokontrollBilder={isLoadingMiljokontrollBilder}
                  />
                </>
              )}
              <Ettersendelser />
              <NyeEttersendelser />
              <KlageinformasjonContainer miljogebyrId={miljogebyr.id} />
              <KlagebehandlingInformasjonContainer
                miljogebyrId={miljogebyr.id}
              />
            </div>
          </Tab>
          <Tab eventKey={2} title="Kart">
            <Map lat={miljogebyr.latitude} lng={miljogebyr.longitude} />
          </Tab>
        </Tabs>
      </div>
    );
  }

  return (
    <div>
      <Spinner isLoading />
    </div>
  );
}
